import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { StepFunctions } from "../joyrideSteps";
import { joyrideService } from "../joyrideService";
import TutorialSkipConfirmationContent from "../components/TutorialSkipConfirmationContent";

interface StartStepProps {
    setShowStartStep?: React.Dispatch<React.SetStateAction<boolean>>;
}

const StartStep: React.FC<StartStepProps & StepFunctions> = ({ setShowStartStep, goToNextStep }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { branchId } = useParams();
    const handleBackClick = () => {
        localStorage.setItem("run", "false");
        localStorage.removeItem("step");
        joyrideService.clearUser();
        navigate(`/logbook/journal/${branchId}`);
    };
    const closeStartStep = () => {
        if (setShowStartStep) {
            setShowStartStep(false);
            return;
        }

        goToNextStep?.();
    };

    return (
        <TutorialSkipConfirmationContent
            title={t("Want to learn on your own?")}
            description={t("Save your time by taking a quick online training course")}
            additionalDescription={
                <Trans
                    i18nKey="You can take the training later by clicking the button <strong>How to connect Online Booking?</strong> in the menu."
                    components={{ strong: <strong /> }}
                />
            }
            onContinueTutorial={closeStartStep}
            onSkipTutorial={handleBackClick}
        />
    );
};

export default StartStep;
